export default __webpack_public_path__ + "static/media/PHP.68353599.svg";